module.exports = __webpack_public_path__ + "static/img/04wr.9e71c945.webp";